import { ActionsUnion, createAction } from 'spw-redux/types';

export const SET_CURRENT_VIEW = 'buildingDetail/SET_CURRENT_VIEW';

export const setCurrentView = (currentView: string) =>
  createAction(SET_CURRENT_VIEW, { currentView });

export const actions = {
  setCurrentView,
};

export type Actions = ActionsUnion<typeof actions>;
